import { Review } from 'types';

const TEAM_REVIEWERS = ['alice', 'nikolai', 'ilya', 'ilia'];

export const isTeamReview = (review: Review) =>
  TEAM_REVIEWERS.includes(review.authorName.trim().toLowerCase());
